import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "PennySparkle__IconWrapper",
  componentId: "sc-1kkycil-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 60 60",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    fillRule: "evenodd",
    d: "M29.885 5.962C27.92 26.984 26.33 28.54 5 30.478 26.33 32.406 27.92 33.986 29.885 55c1.97-21.014 3.561-22.594 24.9-24.522-21.338-1.936-22.93-3.494-24.9-24.516M10.127 42.504c-.393 4.354-.714 4.678-4.986 5.08 4.273.398 4.593.726 4.986 5.078.395-4.352.713-4.68 4.987-5.079-4.274-.401-4.592-.725-4.987-5.08M47.328 5c-.605 6.7-1.094 7.196-7.667 7.813 6.573.614 7.062 1.12 7.668 7.815.606-6.696 1.097-7.2 7.672-7.815-6.574-.617-7.065-1.114-7.672-7.813",
    clipRule: "evenodd"
  }));
}
const PennySparkle = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(PennySparkle);
export default Memo;